import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { BlockableUI } from 'primeng/api';

@Component({
  selector: 'vb-blocker',
  templateUrl: './vb-blocker.component.html',
  styleUrls: ['./vb-blocker.component.scss'],
  standalone: false //NOSONAR
})
export class VbBlockerComponent implements OnInit, OnChanges {
  private elementRef = inject(ElementRef);

  private timeout: ReturnType<typeof setTimeout>;
  @Input() blocked: boolean;
  block: boolean;
  @Input() messageVisible: boolean;
  @Input() message: string;
  @Input() displayMessageAfter = 0; // default value, overwrite in view
  @Output() onClose = new EventEmitter<boolean>();
  @Input() unblockAllowed = false;
  @Input() unblockBtnLabel = 'Refresh';
  @Output() refresh = new EventEmitter<any>();
  @Input() positionCentered = false;
  @Input() isDisplayed = true;
  @Input() blockerType = '';
  @Input() importStatus = '';
  @Input() importPercent = 0;
  @Input() data: any;
  resolvedTarget: BlockableUI | null = null;

  ngOnChanges(changes: SimpleChanges) {
    //let currentItem: SimpleChange = changes["blocked"];
    //currentItem &&
    //this.startCountDown();
    if (this.blocked) {
      this.startCountDown();
    } else {
      this.unBlock(false);
    }
  }

  ngOnInit() {
    // Create a BlockableUI wrapper for the parent element
    const parentEl = this.elementRef.nativeElement.parentElement;
    if (parentEl) {
      this.resolvedTarget = {
        getBlockableElement: () => parentEl
      };
    }
    if (this.blocked) {
      this.startCountDown();
    } else {
      this.unBlock(false);
    }
  }

  startCountDown(): void {
    this.cleanUp();
    if (this.displayMessageAfter <= 0) {
      return;
    }
    this.timeout = setTimeout(() => {
      this.messageVisible = true;
    }, this.displayMessageAfter);
  }

  unBlock(needRefresh) {
    this.cleanUp();
    this.blocked = false;
    if (needRefresh) {
      this.refresh.emit(false);
    }
  }

  private cleanUp() {
    this.messageVisible = false;
    clearTimeout(this.timeout);
  }
}
